import * as TimeUtils from '@acceligentllc/shared/utils/time';

export const getYesterday = () => {
	const today = new Date();
	const yesterday = TimeUtils.addDays(today, -1).toDate();
	return yesterday;
};
